import { ShieldCheck, BadgeCheck } from "lucide-react";
import { Reveal } from "./Reveal";

export const Compliance = () => (
  <section id="icai-compliance" className="py-16 sm:py-24 bg-ink text-paper" data-testid="compliance-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal className="text-center max-w-2xl mx-auto">
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-brass font-semibold mb-4">Regulated & Accountable</p>
        <h2 className="font-serif text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight">
          ICAI Credentials, displayed as required.
        </h2>
      </Reveal>
      <div className="mt-14 grid sm:grid-cols-2 gap-6 max-w-4xl mx-auto">
        <Reveal delay={0.1}>
          <div className="rounded-3xl border border-white/15 bg-white/5 backdrop-blur-sm p-8 text-center transition-colors duration-500 hover:border-brass/50" data-testid="icai-membership-card">
            <ShieldCheck size={28} className="mx-auto text-brass" strokeWidth={1.6} />
            <p className="mt-4 font-mono text-xs uppercase tracking-[0.25em] text-paper/60">ICAI Membership No.</p>
            <p className="mt-2 font-serif text-4xl sm:text-5xl font-semibold text-brass tracking-tight">448639</p>
            <p className="mt-3 text-sm text-paper/70">CA Shashank Chaudhary</p>
          </div>
        </Reveal>
        <Reveal delay={0.2}>
          <div className="rounded-3xl border border-white/15 bg-white/5 backdrop-blur-sm p-8 text-center transition-colors duration-500 hover:border-brass/50" data-testid="icai-frn-card">
            <BadgeCheck size={28} className="mx-auto text-brass" strokeWidth={1.6} />
            <p className="mt-4 font-mono text-xs uppercase tracking-[0.25em] text-paper/60">Firm Registration No.</p>
            <p className="mt-2 font-serif text-4xl sm:text-5xl font-semibold text-brass tracking-tight">029777C</p>
            <p className="mt-3 text-sm text-paper/70">Shashank Chaudhary &amp; Co</p>
          </div>
        </Reveal>
      </div>
      <Reveal delay={0.3}>
        <p className="mt-12 max-w-3xl mx-auto text-center text-xs sm:text-sm leading-relaxed text-paper/50" data-testid="icai-disclaimer">
          Disclaimer: As per the guidelines of the Institute of Chartered Accountants of India (ICAI),
          this website is intended solely to provide information about Shashank Chaudhary &amp; Co and its
          services. It does not constitute an advertisement, solicitation, or invitation for professional
          work. By accessing this website, you acknowledge that you are seeking information of your own
          accord and that no client–firm relationship is created by your use of this site.
        </p>
      </Reveal>
    </div>
  </section>
);
